module.exports = __webpack_public_path__ + "img/display-3-select.386c4e7c.svg";